module.exports = __webpack_public_path__ + "img/image-not-found-cs.dfc2fae2.jpg";